import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'translateFormat',
    standalone: false
})
export class TranslateFormatMockPipe implements PipeTransform {
    transform(key: string, ...params: any[]): string {
        return key;
    }
}
